import axios from 'axios';
import {
    NEWSFLASH_DETAILS_FAIL,
    NEWSFLASH_DETAILS_REQUEST,
    NEWSFLASH_DETAILS_SUCCESS,
    NEWSFLASH_LOGIN_FAIL,
    NEWSFLASH_LOGIN_REQUEST,
    NEWSFLASH_LOGIN_SUCCESS,
    NEWSFLASH_LOGOUT,

    NEWSFLASH_REGISTER_FAIL,
    NEWSFLASH_REGISTER_REQUEST,
    NEWSFLASH_REGISTER_SUCCESS,
    
    NEWSFLASH_UPDATE_PROFILE_REQUEST,
    NEWSFLASH_UPDATE_PROFILE_SUCCESS,
    NEWSFLASH_UPDATE_PROFILE_FAIL,
    NEWSFLASH_DETAILS_RESET,
    NEWSFLASH_LIST_FAIL,
    NEWSFLASH_LIST_REQUEST,
    NEWSFLASH_LIST_SUCCESS,
    NEWSFLASH_LIST_RESET,
    NEWSFLASH_DELETE_REQUEST,
    NEWSFLASH_DELETE_SUCCESS,
    NEWSFLASH_DELETE_FAIL,
    NEWSFLASH_UPDATE_REQUEST,
    NEWSFLASH_UPDATE_SUCCESS,
    NEWSFLASH_UPDATE_FAIL
} from '../constants/newsflashConstants.js';

 export const login = (titre, text, link) => async (dispatch) => {
     try {
         dispatch({
             type: NEWSFLASH_LOGIN_REQUEST,
         });
 
         const config = {
             headers: {
                 'Content-type': 'application/json'
             },
         };
 
         const { data } = await axios.post(
             '/api/newsflashs/login',
             { titre, text,  link },
             config
         );
 
         dispatch({
             type: NEWSFLASH_LOGIN_SUCCESS,
             payload: data
         });
 
         localStorage.setItem('newsflashInfo', JSON.stringify(data));
     } catch (error) {
         dispatch({
             type: NEWSFLASH_LOGIN_FAIL,
             payload:
                 error.response && error.response.data.message
                     ? error.response.data.message
                     : error.message
         });
     }
 };

export const register = ( titre, text , link) => async (dispatch) => {
    try {
        dispatch({
            type: NEWSFLASH_REGISTER_REQUEST,
        });

        const config = {
            headers: {
                'Content-type': 'application/json'
            },
        };

        const { data } = await axios.post(
            '/api/newsflashs/',
            {  titre, text, link },
            config
        );

        dispatch({
            type: NEWSFLASH_REGISTER_SUCCESS,
            payload: data
        });

        dispatch({
            type: NEWSFLASH_LOGIN_SUCCESS,
            payload: data
        });

        localStorage.setItem('newsflashInfo', JSON.stringify(data));
    } catch (error) {
        dispatch({
            type: NEWSFLASH_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        });
    }
};

export const getNewsflashDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: NEWSFLASH_DETAILS_REQUEST,
        });

        const  { newsflashRegister: { newsflashInfo } } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${newsflashInfo.token}`
            },
        };

        const { data } = await axios.get(
            `/api/newsflashs/${id}`,
            config
        );

        dispatch({
            type: NEWSFLASH_DETAILS_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: NEWSFLASH_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        });
    }
};

export const updateNewsflashProfile = (newsflash) => async (dispatch, getState) => {
    try {
        dispatch({
            type: NEWSFLASH_UPDATE_PROFILE_REQUEST,
        });

        const { newsflashRegister: { newsflashInfo } } = getState();

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${newsflashInfo.token}`
            },
        };

        const { data } = await axios.put(
            '/api/newsflashs/profile',
            newsflash,
            config
        );

        dispatch({
            type: NEWSFLASH_UPDATE_PROFILE_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: NEWSFLASH_UPDATE_PROFILE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        });
    }
};

//  export const listNewsflashs = () => async (dispatch, getState) => {
//      try {
//          dispatch({
//              type: NEWSFLASH_LIST_REQUEST,
//          });
//  
//          const { newsflashRegister: { newsflashInfo } } = getState();
//  
//          const config = {
//              headers: {
//                  Authorization: `Bearer ${newsflashInfo.token}`
//              },
//          };
//  
//          const { data } = await axios.get('/api/newsflashs', config);
//  
//          dispatch({
//              type: NEWSFLASH_LIST_SUCCESS,
//              payload: data
//          });
//  
//      } catch (error) {
//          dispatch({
//              type: NEWSFLASH_LIST_FAIL,
//              payload:
//                  error.response && error.response.data.message
//                      ? error.response.data.message
//                      : error.message
//          });
//      }
//  };


export const listNewsflashs = () => async (dispatch) => {
    try {
        dispatch({ type: NEWSFLASH_LIST_REQUEST  })

        const { data } = await axios.get('/api/newsflashs')

        dispatch({
            type: NEWSFLASH_LIST_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch({
            type: NEWSFLASH_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}


export const deleteNewsflashs = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: NEWSFLASH_DELETE_REQUEST,
        });

        const { newsflashRegister: { newsflashInfo } } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${newsflashInfo.token}`
            },
        };

        // eslint-disable-next-line no-unused-vars
        const { data } = await axios.delete(`/api/newsflashs/${id}`, config);

        dispatch({
            type: NEWSFLASH_DELETE_SUCCESS,
        });

    } catch (error) {
        dispatch({
            type: NEWSFLASH_DELETE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        });
    }
};

export const updateNewsflash = (newsflash) => async (dispatch, getState) => {
    try {
        dispatch({
            type: NEWSFLASH_UPDATE_REQUEST,
        });

        const { newsflashRegister: { newsflashInfo } } = getState();

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${newsflashInfo.token}`
            },
        };

        const { data } = await axios.put(`/api/newsflashs/${newsflash._id}`, newsflash, config);

        
        dispatch({ type: NEWSFLASH_UPDATE_SUCCESS });

        dispatch({
            type: NEWSFLASH_DETAILS_SUCCESS,
            payload: data
        });

        dispatch({ type: NEWSFLASH_DETAILS_RESET });

    } catch (error) {
        dispatch({
            type: NEWSFLASH_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        });
    }
};

export const logout = () => (dispatch) => {
    localStorage.removeItem('newsflashInfo');
    dispatch({ type: NEWSFLASH_LOGOUT });
    dispatch({ type: NEWSFLASH_DETAILS_RESET });
    dispatch({ type: NEWSFLASH_LIST_RESET });
};
